export class ConcurrentCallLimit<T> {
    callLimit: number;
    currentCalls: number = 0;
    callQueue: StoredConcurrentCall<T>[] = [];

    constructor(callLimit: number) {
        this.callLimit = callLimit;
    }

    run(action: () => Promise<T>): Promise<T> {
        let self = this;

        if (self.currentCalls < this.callLimit) {
            self.currentCalls++;
            let promise = action();
            promise.finally(() => {
                self.currentCalls--;
                self.triggerNextCall();
            });
            return promise;
        } else {
            let limit = new StoredConcurrentCall<T>;
            limit.action = action;
            self.callQueue.push(limit);

            return new Promise<T>((resolve, reject) => {
                limit.resolve = resolve;
                limit.reject = reject;
            });
        }
    }

    async triggerNextCall() {
        if (this.callQueue.length > 0) {
            let self = this;
            let nextCall = self.callQueue.shift();
            self.currentCalls++;
            let callAction = nextCall.action();
            callAction.finally(() => {
                self.currentCalls--;
                self.triggerNextCall();
            });
            callAction.then((result) => {
                nextCall.resolve(result);
            }, reject => {
                nextCall.reject(reject);
            });
        }
    }
}

class StoredConcurrentCall<T> {
    resolve: (value: T | PromiseLike<T>) => void;
    reject: (reason: string) => void;
    action: () => Promise<T>;

}
